import { Box, Card, Input, Label, Text } from '@nimbus-ds/components';

const renderInputSkeleton = (key: string) => (
  <Box key={key} display="flex" flexDirection="column" gap="2">
    <Text.Skeleton aria-hidden="true" />
    <Input.Skeleton aria-hidden="true" />
    <Label.Skeleton aria-hidden="true" />
  </Box>
);

function PagoNubeOnboardingSkeleton() {
  return (
    <Box>
      <Card>
        {Array.from({ length: 4 }, (_, i) => renderInputSkeleton(`${i}`))}
      </Card>
    </Box>
  );
}

export default PagoNubeOnboardingSkeleton;
